import React, { useEffect, useState } from 'react';
import {
  FaLightbulb,
  FaTools,
  FaBriefcase,
  FaUsers,
  FaBullhorn,
  FaMoneyBillWave,
  FaChartLine,
  FaUserTie,
  FaMoneyBillWaveAlt,
} from 'react-icons/fa';
import { apiClient } from '../../config';

const tabs = [
  {
    name: "Ideation & Validation",
    icon: <FaLightbulb />,
    subCategories: [
      { label: "Problem Discovery" },
      { label: "Design Thinking" },
      { label: "Market Research" },
      { label: "Market Sizing (TAM/SAM/SOM)" },
      { label: "Competitor Analysis" },
      { label: "Customer Persona" },
      { label: "Value Proposition" },
      { label: "Validation Methods" },
      { label: "Business Model" },
    ],
  },
  {
    name: "Financial Literacy",
    icon: <FaMoneyBillWaveAlt />,
    subCategories: [
      { label: "Money Basics & Financial Mindset" },
      { label: "Accounting & Financial Statements (Simplified)" },
      { label: "Unit Economics & Business Model Finance" },
    ],
  },
  {
    name: "Marketing Literacy",
    icon: <FaBullhorn />,
    subCategories: [
      { label: "Marketing Fundamentals" },
      { label: "Branding, Messaging & Startup Narrative" },
      { label: "Unit Economics & Business Model Finance" },
    ],
  },
  {
    name: "Product Development",
    icon: <FaTools />,
    subCategories: [
      { label: "MVP & Prototyping" },
      { label: "Startup UI/UX" },
      { label: "Tech Stack" },
      { label: "No-Code Tools" },
      { label: "DevOps & CI/CD" },
      { label: "Cloud Architecture" },
      { label: "Agile & Scrum" },
      { label: "AI/ML Tools" },
      { label: "Product-Market Fit" },
      { label: "Cybersecurity" },
    ],
  },
  {
    name: "Business Setup",
    icon: <FaBriefcase />,
    subCategories: [
      { label: "Company Formation" },
      { label: "Entity Types" },
      { label: "Founder Agreements" },
      { label: "SOPs" },
      { label: "Financial Planning" },
      { label: "Compliance" },
      { label: "IP & Licensing" },
      { label: "Startup Insurance" },
      { label: "Contract Mgmt" },
      { label: "Bookkeeping" },
    ],
  },
  {
    name: "Talent & Culture",
    icon: <FaUsers />,
    subCategories: [
      { label: "Cofounder Hiring" },
      { label: "HR Best Practices" },
      { label: "Talent Acquisition" },
      { label: "Remote Teams" },
      { label: "Org Design" },
      { label: "Equity & ESOPs" },
      { label: "Onboarding" },
      { label: "Company Culture" },
      { label: "Team Dynamics" },
      { label: "Payroll & Compliance" },
    ],
  },
  {
    name: "Sales & Marketing",
    icon: <FaBullhorn />,
    subCategories: [
      { label: "GTM Strategy" },
      { label: "Sales Funnel" },
      { label: "First Customers" },
      { label: "Sales Strategy" },
      { label: "Sales Team & CRM" },
      { label: "Marketing Strategy" },
      { label: "Social & Influencer" },
      { label: "Paid Ads" },
      { label: "SEO & Content" },
      { label: "Partnerships" },
      { label: "A/B Testing" },
      { label: "Customer Success" },
    ],
  },
  {
    name: "Funding",
    icon: <FaMoneyBillWave />,
    subCategories: [
      { label: "Fundraising 101" },
      { label: "Funding Instruments" },
      { label: "Pitch Deck" },
      { label: "Valuation & Models" },
      { label: "Investor Outreach" },
      { label: "Term Sheets" },
      { label: "Cap Table Tools" },
      { label: "Grants & Non-Equity" },
      { label: "Crowdfunding" },
      { label: "Investor Relations" },
    ],
  },
  {
    name: "Scaling",
    icon: <FaChartLine />,
    subCategories: [
      { label: "Ops & Infra Scaling" },
      { label: "Growth Metrics" },
      { label: "Customer Support" },
      { label: "Intl Expansion" },
      { label: "Localization" },
      { label: "Cross-Border Legal" },
      { label: "M&A Strategy" },
      { label: "IPO Readiness" },
      { label: "Exit Planning" },
      { label: "Legacy & Succession" },
    ],
  },
  {
    name: "Founder Excellence",
    icon: <FaUserTie />,
    subCategories: [
      { label: "Founder Psychology" },
      { label: "Time & Decisions" },
      { label: "Communication Skills" },
      { label: "Pitching & Speaking" },
      { label: "Personal Branding" },
      { label: "Networking" },
      { label: "Advisors & Mentors" },
      { label: "Crisis Management" },
      { label: "Ethics & Impact" },
    ],
  },
];

const AddCourses = () => {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [subcategories, setSubcategories] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    modules: '',
    description: '',
    language: 'English',
    rating: 1,
    level: 'Beginner',
    milestone: 'M1',
    tags: '',
    thumbnail: null,
  });
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await apiClient.get('/api/course/courses');
      const data = res.data;
      console.log('Fetched courses:', data);
      setCourses(Array.isArray(data) ? data : data.data || []);
    } catch (err) {
      console.error('Error fetching courses:', err);
    }
  };

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    const selectedTab = tabs.find((tab) => tab.name === category);
    setSubcategories(selectedTab ? selectedTab.subCategories : []);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCategory || !selectedSubcategory || !formData.title) {
      alert("Please fill in the required fields (Category, Subcategory, Title)");
      return;
    }

    const courseForm = new FormData();
    courseForm.append('title', formData.title);
    courseForm.append('category', selectedCategory);
    courseForm.append('subcategory', selectedSubcategory);
    courseForm.append('description', formData.description);
    courseForm.append('language', formData.language);
    courseForm.append('rating', formData.rating || '4.0');
    courseForm.append('level', formData.level || 'Beginner');
    courseForm.append('milestone', formData.milestone || '');
    courseForm.append('tags', formData.tags || '');

    if (formData.thumbnail instanceof File) {
      courseForm.append('thumbnail', formData.thumbnail);
    }

    setLoading(true);
    try {
      const response = await apiClient.post('/api/course/courses', courseForm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Create course response:', response.data);
      alert('✅ Course created successfully!');
      
      // Reset form
      setSelectedCategory('');
      setSelectedSubcategory('');
      setSubcategories([]);
      setFormData({
        title: '',
        modules: '',
        description: '',
        language: 'English',
        rating: 1,
        level: 'Beginner',
        milestone: 'M1',
        tags: '',
        thumbnail: null,
      });
      fetchCourses();
    } catch (err) {
      console.error('❌ Submit error:', err);
      alert(err.response?.data?.message || err.message || 'Course submission failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-bottom py-3">
                <h5 className="mb-0 fw-semibold">Create Course</h5>
              </div>
              <div className="card-body">
                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Course Category *</label>
                    <select className="form-select" value={selectedCategory} onChange={handleCategoryChange}>
                      <option value="">-- Select Category --</option>
                      {tabs.map((tab, i) => <option key={i} value={tab.name}>{tab.name}</option>)}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Subcategory *</label>
                    <select className="form-select" value={selectedSubcategory} onChange={(e) => setSelectedSubcategory(e.target.value)}>
                      <option value="">-- Select Subcategory --</option>
                      {subcategories.map((sub, i) => <option key={i} value={sub.label}>{sub.label}</option>)}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Course Title *</label>
                    <input type="text" className="form-control" placeholder="Enter course title" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Total No of Modules</label>
                    <input type="number" className="form-control" placeholder="e.g. 5" value={formData.modules} onChange={(e) => setFormData({ ...formData, modules: e.target.value })} />
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold">Course Description</label>
                    <textarea className="form-control" rows="3" placeholder="Provide a brief summary of the course" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Language</label>
                    <select className="form-select" value={formData.language} onChange={(e) => setFormData({ ...formData, language: e.target.value })}>
                      <option>English</option>
                      <option>Hindi</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Initial Rating</label>
                    <select className="form-select" value={formData.rating} onChange={(e) => setFormData({ ...formData, rating: e.target.value })}>
                      {[1, 2, 3, 4, 5].map((n) => <option key={n}>{n}</option>)}
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Skill Level</label>
                    <select className="form-select" value={formData.level} onChange={(e) => setFormData({ ...formData, level: e.target.value })}>
                      <option>Beginner</option>
                      <option>Intermediate</option>
                      <option>Advanced</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Milestone Level</label>
                    <select className="form-select" value={formData.milestone} onChange={(e) => setFormData({ ...formData, milestone: e.target.value })}>
                      <option>M1</option>
                      <option>M2</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Keyword Tags</label>
                    <input type="text" className="form-control" placeholder="e.g. startup, validation, ideation" value={formData.tags} onChange={(e) => setFormData({ ...formData, tags: e.target.value })} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Upload Thumbnail</label>
                    <input type="file" className="form-control" onChange={(e) => setFormData({ ...formData, thumbnail: e.target.files[0] })} />
                  </div>

                  <div className="col-md-6 d-flex align-items-end">
                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                      {loading ? 'Creating...' : 'Create Course'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Table - Full Width Below Form */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-bottom py-3">
                <h5 className="mb-0 fw-semibold">Course Details</h5>
              </div>
              <div className="card-body p-0 table-responsive">
                <table className="table table-hover table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th className="ps-4" style={{ width: "60px" }}>SNO.</th>
                      <th>Category</th>
                      <th>Subcategory</th>
                      <th>Course Name</th>
                      <th>Course Description</th>
                      <th>Milestone</th>
                      <th className="pe-4 text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses?.length > 0 ? (
                      courses.map((course, i) => (
                        <tr key={course._id}>
                          <td className="ps-4">{i + 1}</td>
                          <td className="fw-semibold">{course.category}</td>
                          <td>{course.subcategory || '-'}</td>
                          <td className="fw-semibold">{course.title}</td>
                          <td>{course.description}</td>
                          <td>{course.milestone || '-'}</td>
                          <td className="pe-4 text-end">
                            <button className="btn btn-sm btn-outline-primary">Edit</button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4 text-muted">
                          No courses found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default AddCourses;
